import { useEffect, useState, useMemo } from "react";

const AutoCarousel = ({
  images = [],
  interval = 3000,
  altPrefix = "slide",
}) => {
  // Normalize to [{src, alt}]
  const slides = useMemo(
    () =>
      images.map((img, i) =>
        typeof img === "string"
          ? { src: img, alt: `${altPrefix} ${i + 1}` }
          : img
      ),
    [images, altPrefix]
  );

  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) return; // nothing to rotate
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % slides.length);
    }, interval);
    return () => clearInterval(id);
  }, [slides.length, interval]);

  return (
    <div className="autoCarousel" aria-roledescription="carousel">
      {slides.map((s, i) => (
        <img
          key={i}
          src={s.src}
          alt={s.alt || `${altPrefix} ${i + 1}`}
          className={`autoCarousel__slide ${i === index ? "is-active" : ""}`}
          aria-hidden={i === index ? "false" : "true"}
          loading="lazy"
          draggable="false"
        />
      ))}
    </div>
  );
};

export default AutoCarousel;
